
import { css } from 'lit';
export default css`
:host svg{
    display:flex;
    height:100%;
    width:100%;
  }

.animate{
  stroke-dasharray:var(--line-length);
  stroke-dashoffset:var(--line-length);
  animation:dash 1.5s linear forwards;
  animation-delay:var(--animation-delay);
}

@keyframes dash{
  from{
    stroke-dashoffset:var(--line-length);
  }
  to{
    stroke-dashoffset:0;
  }
}

`;